import request from 'sb-request'
import { reducers, getState } from 'redux/core'
import getGqlQuery from 'common/helpers/getters/getGqlQuery'
import { ageCategoryEnum } from 'common/helpers/getters/getAgeCategoryFromBirthday/getAgeCategoryFromBirthday'


const { reset } = reducers.view.improveRecommendationsPage

const fetchSearch = (query) => {
  reducers.view.improveRecommendationsPage.setFetching(true)

  return request.get('rest/engine/fr_search', {
    query: {
      query: String(query),
    },
    modifyResult: ({ suggestions = [] }) => (
      suggestions.map(({ name, brand, value, data, img }) => ({
        name,
        brand,
        image: img,
        fullName: value,
        id: data,
      }))
    ),
  })
    .then((items) => reducers.view.improveRecommendationsPage.setSearchResults(items))
}

const resetSearch = () => {
  reducers.view.improveRecommendationsPage.setSearchResults([])
}

const rateItem = (item, status, ageCategory) => {
  const input = {
    productId: item.id,
    status: {
      value: status,
      isEnum: true,
    },
    ageCategory: {
      value: ageCategoryEnum[ageCategory],
      isEnum: true,
    },
  }

  reducers.view.improveRecommendationsPage.saveItem({ item, status })

  return request.post('graphql?name=voteFragranticaProduct', {
    body: {
      query: `
        mutation { 
          ${getGqlQuery('voteFragranticaProduct', { input })} {
            result
          }
        }
      `,
    },
  })
}

// When user set age category, we should save items again
const rerateWithAgeCategory = (ageCategory) => {
  if (!Boolean(ageCategory)) {
    return Promise.resolve()
  }

  const { view: { improveRecommendationsPage: { savedItems } } } = getState()

  const query = Object.values(savedItems).reduce((result, item) => {
    const input = {
      productId: item.id,
      status: {
        value: item.status,
        isEnum: true,
      },
      ageCategory: {
        value: ageCategoryEnum[ageCategory],
        isEnum: true,
      },
    }

    return `
      ${result}
      x${item.id}: ${getGqlQuery('voteFragranticaProduct', { input })} {
        result
      }
    `
  }, '')

  return request.post('graphql?name=voteFragranticaProduct', {
    body: {
      query: `
        mutation {
          ${query}
        }
      `,
    },
  })
}


export default {
  fetchSearch,
  resetSearch,
  rateItem,
  rerateWithAgeCategory,
  reset,
}
